import { PolicyFilter } from "../../../hooks/useGetPolicies";
import { PaginationQueryObject, QueryConfig } from "./Queries";

export const policiesQuery = (
  filter: PolicyFilter,
  paginationInput: PaginationQueryObject
): QueryConfig => {
  const query = `query getPolicies($filter: PolicyFilter, $paginationInput: PaginationInput) {
  policies(filter: $filter, paginationInput: $paginationInput) {
    pageInfo {
      totalElements
    }
    items {
      id
      name
      description
      isAssignedToRoleId
      scope {
        id
        name
        applications {
          name
        }
      }
      permissions {
        id
        displayName
        description
      }
    }
  }
}`;

  return {
    query: query,
    variables: {
      filter,
      paginationInput,
    },
  };
};
